import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="font-playfair text-2xl font-bold mb-4">Villa Renaissance Garden</h3>
            <p className="text-white/80 mb-6">A 16th-century escape in the heart of Dubrovnik</p>
            
            {/* Airbnb Trust Badge */}
            <a 
              href="https://www.airbnb.com/rooms/36517649?source_impression_id=p3_1774275773_P36zG1iQyJKkzDXq"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white/10 hover:bg-white/20 px-4 py-3 rounded-sm transition-all group"
              data-testid="airbnb-trust-badge"
            >
              <svg 
                className="w-8 h-8" 
                viewBox="0 0 32 32" 
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <path d="M16 1c-1.663 0-3.005 1.342-3.005 3.005 0 .775.301 1.477.785 2.01-.484.533-.785 1.235-.785 2.01 0 1.663 1.342 3.005 3.005 3.005s3.005-1.342 3.005-3.005c0-.775-.301-1.477-.785-2.01.484-.533.785-1.235.785-2.01 0-1.663-1.342-3.005-3.005-3.005zm8.23 9.655c-1.379-1.379-3.614-1.379-4.993 0l-3.237 3.237-3.237-3.237c-1.379-1.379-3.614-1.379-4.993 0s-1.379 3.614 0 4.993l8.23 8.23 8.23-8.23c1.379-1.379 1.379-3.614 0-4.993z"/>
              </svg>
              <div className="text-left">
                <div className="text-xs text-white/60">Find us on Airbnb</div>
                <div className="text-sm font-semibold flex items-center gap-1">
                  Superhost Verified
                  <ExternalLink size={12} className="group-hover:translate-x-0.5 transition-transform" />
                </div>
              </div>
            </a>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Location</h4>
            <p className="text-white/80">
              Mokošica, Dubrovnik<br />
              Croatia
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <p className="text-white/80">
              Hosts: Slavica & Marijo<br />
              <Link to="/contact" className="underline hover:text-white/60">Send inquiry</Link>
            </p>
          </div>
        </div>
        <div className="border-t border-white/20 mt-12 pt-8 text-center text-white/60 text-sm">
          © {new Date().getFullYear()} Villa Renaissance Garden. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;